import usePrivateAxios from "@/common/api/usePrivateAxios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { FindRewardItemByCodeData } from "../types/findRewardItemByCode.type";

type UseFindRewardItemByCodeProps = {
  filters?: {
    code?: string;
  };
};

export const useFindRewardItemByCode = ({
  filters: { code } = {},
}: UseFindRewardItemByCodeProps) => {
  const privateAxios = usePrivateAxios();

  const {
    data,
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['findRewardByCode', code],
    queryFn: async () => {
      const response = await privateAxios.get<{ data: FindRewardItemByCodeData }>(
        `/tmais/reward_product_redemptions/find_by_code`,
        {
          params: { code: code?.toUpperCase() },
        }
      );
      
      return response.data.data;
    },
    placeholderData: keepPreviousData,
    enabled: code?.length === 11, 
  });

  return { data, isPending, ...rest };
};